export function generateUniqueId() {
  return `__${btoa(String(Math.random() + Math.random())).toLowerCase().substr(10, 10)}__`;
}

export function getServerApiPrefix() {
  return __DEVELOPMENT__ ? 'http://localhost:8181/api' : '/api';
}
